import { render, staticRenderFns } from "./NoticeSettingEdit.vue?vue&type=template&id=5759fed4&scoped=true"
import script from "./NoticeSettingEdit.vue?vue&type=script&lang=ts"
export * from "./NoticeSettingEdit.vue?vue&type=script&lang=ts"
import style0 from "./NoticeSettingEdit.vue?vue&type=style&index=0&id=5759fed4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5759fed4",
  null
  
)

export default component.exports